import { render, staticRenderFns } from "./PromotionPages.vue?vue&type=template&id=6b1751c4&"
import script from "./PromotionPages.vue?vue&type=script&lang=js&"
export * from "./PromotionPages.vue?vue&type=script&lang=js&"
import style0 from "./PromotionPages.vue?vue&type=style&index=0&id=6b1751c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports